import React from 'react';
import Icon from '../../../components/AppIcon';

const EmptyState = () => {
  return (
    <div className="bg-card border border-border rounded-lg p-8 text-center">
      <div className="flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mx-auto mb-4">
        <Icon name="Search" size={32} color="var(--color-primary)" strokeWidth={2} />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">Search for a Driver</h3>
      <p className="text-sm text-muted-foreground max-w-md mx-auto">
        Enter a driver's phone number above to view their current unit assignment, VIN, and yard location. Results appear instantly for active drivers in the fleet.
      </p>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
        <div className="flex flex-col items-center p-4 bg-muted/30 rounded-lg">
          <Icon name="Truck" size={24} color="var(--color-accent)" strokeWidth={2} className="mb-2" />
          <p className="text-xs font-medium text-foreground">Unit Details</p>
        </div>
        <div className="flex flex-col items-center p-4 bg-muted/30 rounded-lg">
          <Icon name="MapPin" size={24} color="var(--color-success)" strokeWidth={2} className="mb-2" />
          <p className="text-xs font-medium text-foreground">Yard Location</p>
        </div>
        <div className="flex flex-col items-center p-4 bg-muted/30 rounded-lg">
          <Icon name="CheckCircle2" size={24} color="var(--color-primary)" strokeWidth={2} className="mb-2" />
          <p className="text-xs font-medium text-foreground">Active Status</p>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;